var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_5878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5651 14.3431C4.5651 12.3615 6.17591 10.7506 8.15755 10.7506H12.793V8.54883H8.15755C4.95911 8.54883 2.36328 11.1447 2.36328 14.3431C2.36328 17.5415 4.95911 20.1374 8.15755 20.1374H12.793V17.9355H8.15755C6.17591 17.9355 4.5651 16.3247 4.5651 14.3431ZM9.3164 15.5019H18.5872V13.1842H9.3164V15.5019ZM19.7461 8.54883H15.1107V10.7506H19.7461C21.7277 10.7506 23.3385 12.3615 23.3385 14.3431C23.3385 16.3247 21.7277 17.9355 19.7461 17.9355H15.1107V20.1374H19.7461C22.9445 20.1374 25.5403 17.5415 25.5403 14.3431C25.5403 11.1447 22.9445 8.54883 19.7461 8.54883Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_5878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8125,
    height: 27.8125,
    fill: "white",
    transform: "translate(0.046875 0.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.3126a6c373a5e22d4dbd7c250a526443.svg";
export { ForwardRef as ReactComponent };